import axiosClient from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { LoginWithSF } from "../utils/inv-exch-amplitude";

export const useAxios = (type?: string) => {
  const navigate = useNavigate();
  const userObj = localStorage.getItem("user-detail");
  const investorAccessToken = localStorage.getItem("investor-access-token");
  const salesforceAccessToken = localStorage.getItem("salesforceAccessToken");
  const userDetail = userObj && JSON.parse(userObj);

  const logoutAPI = async () => {
    try {
      await axiosClient.get("/login/logout", {
        baseURL: process.env.REACT_APP_BASE_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetail?.access_token}`
        }
      });
    } catch (error) {
      console.error("Logout API failed:", error);
    }
  };

  async function refreshToken() {
    try {
      const response = await axiosClient.get("/login/refresh-token", {
        baseURL: process.env.REACT_APP_BASE_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetail.refresh_token}`
        }
      });
      return { ...userDetail, ...response.data.data };
    } catch (error) {
      await logoutAPI();
      localStorage.removeItem("user-detail");
      localStorage.removeItem("salesforceAccessToken");
      localStorage.removeItem("showMap");
      localStorage.removeItem("layout");
      localStorage.removeItem("filter");
      localStorage.removeItem("map-persist");
      navigate("/");
    }
  }

  let accessToken;
  if (userDetail && Object.keys(userDetail)?.length !== 0) {
    if (userDetail?.access_token) {
      accessToken = userDetail?.access_token;
    }
  }

  const Authorization = `Bearer ${
    type === "salesforceApi"
      ? salesforceAccessToken
      : type === "investor"
      ? investorAccessToken
      : accessToken
  }`;
  const axiosConfig = {
    baseURL: `${
      type === "salesforceApi"
        ? process.env.REACT_APP_SALESFORCE_BASE_URL
        : process.env.REACT_APP_BASE_URL
    }`,
    headers: {
      "Content-Type": "application/json",
      Authorization: Authorization
    }
  };
  const axiosInstance = axiosClient.create(axiosConfig);
  useEffect(() => {
    // const params = new URLSearchParams(window.location.search);
    // const cid = params.get("cid");
    // const eq = params.get("eq");
    if (type !== "salesforceApi") {
      const interceptor = axiosInstance.interceptors.response.use(
        (response) => response, // Pass through any successful responses
        async (error) => {
          if (error.response && error.response.status === 401) {
            if (type !== "investor") {
              const userObj = await refreshToken();
              if (userObj) {
                localStorage.setItem("user-detail", JSON.stringify(userObj));
                axiosInstance.defaults.headers[
                  "Authorization"
                ] = `Bearer ${userObj.access_token}`;
                const originalRequest = error.config;
                originalRequest.headers[
                  "Authorization"
                ] = `Bearer ${userObj.access_token}`;
                return axiosClient(originalRequest);
              }
            } else {
              localStorage.removeItem("investor-access-token");
              navigate("/investor-login");
            }
          } else {
            if (type === "investor") {
              navigate("/investor/properties-listing");
            } else {
              return Promise.reject(error);
            }
          }
        }
      );
      return () => {
        axiosInstance.interceptors.response.eject(interceptor);
      };
    }
  }, [axiosInstance, userDetail]);

  return axiosInstance;
};

export const useAxiosWithoutToken = (type?: string) => {
  const axiosConfig = {
    baseURL: `${
      type === "salesforce"
        ? process.env.REACT_APP_SALESFORCE_BASE_URL
        : process.env.REACT_APP_BASE_URL
    }`,
    headers: {
      "Content-Type": "application/json"
    }
  };
  const axiosInstance = axiosClient.create(axiosConfig);

  return axiosInstance;
};
